import React from 'react'

import { CURRENCY_SIGN } from '@/lib/helpers'

import { PriceDefault, PriceOld, PriceWrapper } from './Price.styles'

interface PriceQty {
  children: React.ReactNode
  old?: number
  currency?: string
}

const Price = ({ children, old, currency }: PriceQty) => {
  return (
    <PriceWrapper>
      {old && (
        <PriceOld>
          {Number(old).toFixed(2)} {currency || CURRENCY_SIGN}
        </PriceOld>
      )}
      <PriceDefault $featured={!!old}>
        {Number(children).toFixed(2)} {currency || CURRENCY_SIGN}
      </PriceDefault>
    </PriceWrapper>
  )
}

export default Price
